import { Box, List, Skeleton, Typography } from '@mui/material';
import { ActivityFeed } from 'src/graphql/entities/activity-feed/hooks/use-activity-feed';
import { sortByDate } from 'src/utils/sorting';
import { ActivityListItem, ActivityMessage } from './activity-list-item';

export type ActivityListProps = {
  items: ActivityFeed[];
  messageBuilder: (activity: ActivityFeed) => ActivityMessage[];
  loading?: boolean;
};

export const ActivityList = ({ items, messageBuilder, loading }: ActivityListProps) => {
  if (loading) {
    return (
      <Box sx={{ width: '50%' }}>
        <Skeleton />
        <Skeleton />
        <Skeleton />
      </Box>
    );
  }
  if (items.length === 0 && !loading) {
    return (
      <Box sx={{ p: 2, textAlign: 'center' }}>
        <Typography variant="body1" color="text.secondary">
          No activity to display
        </Typography>
      </Box>
    );
  }
  return (
    <List>
      {items
        .flatMap(messageBuilder)
        .toSorted(sortByDate('timestamp', true))
        .map((value) => (
          <ActivityListItem key={value.id} item={value} />
        ))}
    </List>
  );
};
